<template>
   <div>
        <div class="card-header">
            <p class="title-line1">Kết quả</p>
        </div>
        <div class="card-body">
            <div action="" class="info-submit m-auto text-center">
                <div class="result-block d-flex justify-content-between">
                    <div class="result-item">
                        <p>Listening: <span>{{testResult.listening.sumRightAnser}}/{{testResult.listening.sumQuestion}}</span></p>
                    </div>
                    <div class="result-item">
                        <p>Reading & Writing: <span>{{testResult.reading.sumRightAnser}}/{{testResult.reading.sumQuestion}}</span></p>
                    </div>
                </div>
                <div class="panel-tutorial">
                    <h4>Chúc mừng bạn nhỏ đã hoàn thành bài kiểm tra</h4>
                    <p>Để <strong>Peri</strong> có thể có nhận xét chính xác hơn về trình độ của bạn nhỏ, hãy tham gia buổi học thử với giáo viên của chúng mình nhé.</p>
                    
                    <div class="form-info mb-5">
                        <b-form @submit.prevent="submitTest" class="m-auto mt-5">
                            <b-form-group id="input-group-test_speaking_free" label-for="test_speaking_free" >
                                <h6 style="text-align: left;">Bạn có muốn Test Speaking miễn phí với giáo viên hay không?</h6>
                                <b-form-select
                                    id="test_speaking_free"
                                    v-model="form.test_speaking_free"
                                    :options="testSpeakingOption"
                                    class="mb-3 form-control"
                                    value-field="value"
                                    text-field="text"
                                ></b-form-select>
                            </b-form-group>

                            <b-form-group id="input-group-ho_ten_ba_me" label-for="ho_ten_ba_me" >
                                <b-form-input
                                    id="ho_ten_ba_me"
                                    v-model="form.ho_ten_ba_me"
                                    placeholder="Họ tên Ba/Mẹ"
                                    :required="form.test_speaking_free == 'yes'"
                                    :state="checkStage('ho_ten_ba_me')"
                                    ref="ho_ten_ba_me"
                                />
                                <b-form-invalid-feedback :state="checkStage('ho_ten_ba_me')">{{ getErrorMsg("ho_ten_ba_me") }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="input-group-test_date" label-for="test_date" >
                                <b-form-datepicker
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    locale="vi"
                                    id="test_date"
                                    v-model="form.test_date"
                                    placeholder="Ngày thi speaking dự kiến"
                                    :required="form.test_speaking_free == 'yes'"
                                    :state="checkStage('test_date')"
                                    ref="test_date"
                                />
                                <b-form-invalid-feedback :state="checkStage('test_date')">{{ getErrorMsg('test_date') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group style="text-align: left;" id="input-group-test_time_frame" label-for="test_time_frame" label="Khung giờ có thể tham gia:" v-slot="{ ariaDescribedby }">
                                <b-form-checkbox-group
                                    id="test_time_frame"
                                    v-model="form.test_time_frame"
                                    :options="timeFrame"
                                    :aria-describedby="ariaDescribedby"
                                    name="test_time_frame"
                                    :state="checkStage('test_time_frame')"
                                    ref="test_time_frame"
                                ></b-form-checkbox-group>
                                <b-form-invalid-feedback :state="checkStage('test_time_frame')">{{ getErrorMsg('test_time_frame') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <div class="w-100 text-center">
                                <b-button @click="submit()" type="submit" variant="success" class="btn-custom btn-next">
                                    ĐẶT LỊCH
                                </b-button>
                                <!-- <b-button @click="form.step = 0" variant="primary">Previous</b-button> -->
                            </div>
                        </b-form>
                    </div>
                    
                    <p class="bang-thanks mt-4">Peri cảm ơn và chúc bạn nhỏ có hành trình thật vui<br>và bổ ích với chúng mình nhé!</p>
                </div>
                <!-- <button @click="pushData" class="mt-5 m-auto border-0 bg-transparent">
                    <img class="mw-100" src="../../assets/btn-booking.png" alt="">
                </button> -->
            </div>
        </div>
   </div>
</template>

<script>

// import {
//     BRow,
//     BCol
// } from 'bootstrap-vue'

export default {
    data() {
        return {
            timeFrame: [
                '18:00 - 19:00',
                '19:00 - 20:00',
                '20:00 - 21:00',
                '21:00 - 22:00'
            ],
            nextButtonPress: false,
            form: {
                test_speaking_free: 'yes',
                test_date: '',
                test_time_frame: [],
                ho_ten_ba_me: '',
            },
            testSpeakingOption: [
                { value: 'yes', text: 'Có' },
                { value: 'no', text: 'Không' },
            ],
            
            timeRange: [
                { text: '14h - 15h', checked: false },
                { text: '15h - 16h', checked: false },
                { text: '16h - 17h', checked: false },
                { text: '17h - 18h', checked: false },
                { text: '18h - 19h', checked: false },
                { text: '19h - 20h', checked: false },
                { text: '21h - 22h', checked: false },
            ],
            testResult: {
                listening: {
                    sumQuestion: 0,
                    sumRightAnser: 0
                },
                reading: {
                    sumQuestion: 0,
                    sumRightAnser: 0
                },
            }
        }
    },
    components: {
        // BRow,
        // BCol
    },
    computed: {
        examId () {
            return this.$store.state.examId
        },
    },
    mounted () {
    },
    created() {
        this.getTestResult()
    },
    methods: {

        submitTest (event) {
            event.preventDefault()

            if (
                this.getErrorMsg('test_date') ||
                this.getErrorMsg('test_time_frame') ||
                this.getErrorMsg('ho_ten_ba_me')
            ) {
                return 
            }
            
            this.pushData(this.form)
            .then(() => {
                this.$store.commit('SET_PAGE', 5)
            })
            .catch(error => {
                this.$bvToast.toast(error.message, {
                    title: `Có lỗi xảy ra !`,
                    variant: 'danger',
                    solid: true
                })
            })
        },
        
        submit () {
            this.nextButtonPress = true;
        },

        checkPhone(mobile) {
            let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
            if(mobile !==''){
                if (vnf_regex.test(mobile) == false) {
                    return false
                } else {
                    return true
                }
            }
        },
        checkStage(name) {
            if (!this.nextButtonPress) {
                return null
            }
            
            if (this.form.test_speaking_free == 'yes' && name == 'test_time_frame') {
                if (this.form.test_time_frame.length == 0) {
                    return false
                } else {
                    return true
                }
            }

            const value = this.$refs[name].value ?? ''
            if (
                this.form.test_speaking_free == 'yes' &&
                (value.trim() === '' || value.trim() === ' ')
            ) {
                return false
            }

            if (
                this.form.test_speaking_free == 'yes' &&
                (name == 'sdt_ba_me') &&
                !this.checkPhone(value.trim())
            ) {
                return false
            }

            return true
            
        },




        getErrorMsg (name) {
            if (!this.nextButtonPress) {
                return null
            }

            if (name == 'test_time_frame') {
                if (this.form.test_time_frame.length == 0) {
                    return 'Không được để trống'
                } else {
                    return ''
                }
            }
            
            const value = this.$refs[name].value ?? ''
            if (
                this.form.test_speaking_free == 'yes' &&
                (value.trim() === '' || value.trim() === ' ')
            ) {
                return 'Không được để trống'
            }

            if (
                this.form.test_speaking_free == 'yes' &&
                (name == 'sdt_ba_me') &&
                !this.checkPhone(value.trim())
            ) {
                return 'Số điện thoại không đúng định dạng!' 
            }
        },
        
        getTestResult () {
            this.$http.get('/get-result', {
                params: {
                    test_id: localStorage.getItem(`_speakup_exam${this.examId}`),
                }
            }).then(res => {
                if (res.data.code === 1) {
                    const resultResp = res.data.data
                    
                    if (resultResp[0]) {
                        this.testResult.listening = resultResp[0]
                    }
                    if (resultResp[1]) {
                        this.testResult.reading = resultResp[1]
                    }
                }
            })
        },
        timeCheck(index) {
            this.timeRange[index].checked = !this.timeRange[index].checked
        },

        pushData (data) {

            return new Promise((resolve, reject) => {
                
                const trackid = localStorage.getItem('_speakup_track');

                const contact = JSON.parse(localStorage.getItem('_speakup_userInfo'))
                const storeUserInfo = {...data, ...contact}
                // console.log(storeUserInfo)

                this.$http.post('/track/push-survey', {
                    trackid: trackid,
                    data: storeUserInfo
                })
                .then(resp => {
                    if (resp.data.code == 1) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
                .catch(error => {
                    reject('pushSurveyForm', error)
                })
            })


            // let time = []

            // for (let index = 0; index < this.timeRange.length; index++) {
            //     if (this.timeRange[index].checked) {
            //         time.push(this.timeRange[index].text)
            //     }
                
            // }

            // if (trackid) {
            //     this.$http.post('/test-push-info', {
            //             tracking_id: trackid,
            //             test_id: localStorage.getItem(`_speakup_exam${this.examId}`),
            //             data: {
            //                 time
            //             }
            //         }).then(res => {
            //         if (res.data.code == 1) {
            //             this.$store.commit('SET_PAGE', 5)
            //         }
            //     })
            // }
        },
    }
}
</script>


<style >
    .custom-checkbox {
        display: inline-block;
        margin-right: 25px;
        margin-bottom: 10px;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        border: 1px solid;
    }

    .custom-checkbox>input {
        margin-right: 10px;
        width: 15px;
        height: 15px;
    }

    .form-control, .b-form-datepicker.form-control {
        border-radius: 15px;
        color: #0158a8;
        line-height: 1.5;
        margin-bottom: 20px;
        font-weight: 600;
        height: 50px;
        padding: 5px;
    }

    .b-form-datepicker.form-control .text-muted {
        color: #0158a8 !important;
    }


    .box-tks {
        background-color: #fee138;
        border-radius: 42px;
        color: #0057a7;
        min-height: 400px;
    }

    .box-tks p {
        font-size: 25px;
        text-align: center;
        font-weight: 800;
        text-shadow: 2px 2px #fff,
                     2px -2px #fff,
                    -2px 2px #fff,
                    -2px -2px #fff;
    }
</style>

<style scoped>

.time-list {
    font-family: 'SFU Futura';
}

.checkbox {
    display: flex;
}

.checkbox .check-right {
    background-color: #fc7b32;
    color: #fff;
    border: 3px solid #e35707;
    font-size: 1.4rem;
    padding: 6px;
    border-radius: 14px;
    width: calc(100% - 67px);
    height: 52px;
}

.time-item {
    margin-bottom: 17px;
    cursor: pointer;
}

.title-line1 {
    font-family: 'iCiel Crocante';
    font-size: 2.5rem;
    color: #fc7b32;
}

.checkbox {
    display: flex;
}

.checkbox .check-left {
    border: 3px solid #e35707;
    width: 52px;
    height: 52px;
    border-radius: 14px;
    margin-right: 15px;
}

.result-block {
    margin-top: 20px;
}

.result-item {
    width: 45%;
    background-color: #4cac33;
    border: 2px solid #0a6620;
    color: #fff;
    font-family: 'FS Ariston Comic Base';
    font-size: 2.2rem;
    border-radius: 10px;
}

.result-item p {
    margin: 0;
}

.result-item p span {
    color: #fff000;
}


.panel-tutorial {
    padding: 50px;
    border-radius: 15px;
    border: 3px solid #0099ff;
    background-color: #fff;
    position: relative;
    margin-top: 40px;
}

.panel-tutorial h4 {
    font-family: 'FS Ariston Comic Base';
    color: #fc7b32;
    font-size: 2.8rem;
    margin-bottom: 40px;
}

.panel-tutorial p {
    font-family: 'Roboto-Medium';
    color: #0099ff;
    max-width: 724px;
    margin: auto;
    line-height: 2rem;
    font-size: 1.5rem;
}

.panel-tutorial strong {
    font-family: 'Roboto-Bold';
    color: #0099ff;
}

.bang-thanks {
    font-family: 'FS Ariston Comic Base' !important;
    color: #3b8d26 !important;
    font-size: 2.5rem !important;
    line-height: 2rem !important;
    max-width: 780px !important;
    margin-top: 20px !important;
}

.time-list {
    margin-top: 60px;
}

.time-item.checked .checkbox .check-right {
    background-color: #0099ff;
    border: 3px solid #003995;
}

.time-item.checked .checkbox .check-left {
    border: 3px solid #003995;
    position: relative;
}

.time-item.checked .checkbox .check-left:before {
    position: absolute;
    content: '';
    background: url(../../assets/check.png);
    background-size: contain;
    width: 47px;
    height: 47px;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
}

</style>

<style>

</style>